/** Same groups the category row uses, including the homepage alias `popular` → hot. */
function categoryGroup(id, name = '') {
  const s = `${id || ''} ${name || ''}`.toLowerCase();
  if (/hot|popular|trending/.test(s)) return 'hot';
  if (/sport|cricket|football/.test(s)) return 'sports';
  if (/live\s*casino|casino/.test(s)) return 'casino';
  if (/slot/.test(s)) return 'slots';
  if (/crash|aviator/.test(s)) return 'crash';
  if (/table|poker|blackjack|roulette/.test(s)) return 'table';
  if (/fish/.test(s)) return 'fishing';
  if (/arcade/.test(s)) return 'arcade';
  if (/lotter|keno/.test(s)) return 'lottery';
  return '';
}

/** Direction follows the category row's displayed order, not the label text. */
export function categorySlideDirection(categories, fromId, toId) {
  if (fromId == null || toId == null || fromId === toId) return null;
  if (!Array.isArray(categories)) return null;
  const indexOf = (id) => {
    const exact = categories.findIndex((row) => row && (row.id === id || row.panelId === id));
    if (exact >= 0) return exact;
    const group = categoryGroup(id);
    if (!group) return -1;
    return categories.findIndex((row) => row && categoryGroup(row.id, row.name) === group);
  };
  // An unset homepage selection is the first displayed category.
  const from = fromId === '' ? 0 : indexOf(fromId);
  const to = indexOf(toId);
  if (from < 0 || to < 0 || from === to) return null;
  return to > from ? 'right' : 'left';
}
